import { combineReducers } from 'redux';
import authenticationReducer from './authentication';
import allowanceReducer from './allowance';
import communicationReducer from './communication';
import financialReducer from './finance';
import profileReducer from './profile';
import quoteReducer from './quote';
import registrationFormReducer from './form';
import orderReducer from './order';
import appReducer from './app';
import { RESET_APP } from '../action-types/app';

// https://www.digitalocean.com/community/tutorials/redux-reset-state-redux

const rootReducer = (state, action) => {
    if (action.type === RESET_APP) {
        state = undefined;
      }

    return allReducers(state, action);
  }

const allReducers = combineReducers({
    authentication: authenticationReducer,
    allowance: allowanceReducer,
    communication: communicationReducer,
    finance: financialReducer,
    profile: profileReducer,
    quote: quoteReducer,    
    registrationForm: registrationFormReducer,
    store: orderReducer,
    app: appReducer
});

export default rootReducer;